module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-ties-remnants.c75c250a.png";